import { Edit3 } from "lucide-react";
import { SECTIONS } from "../../lib/insuranceConsultationSchema";

// Human-friendly renderer of a single answer
const renderAnswer = (q, answers) => {
  const v = answers[q.id];
  if (q.type === "height") {
    return `${answers.heightFeet || 0}′ ${answers.heightInches || 0}″`;
  }
  if (q.type === "nameGroup") {
    return [answers.firstName, answers.middleName, answers.lastName, answers.suffix]
      .filter(Boolean)
      .join(" ");
  }
  if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
  if (v === undefined || v === null || v === "") return "—";
  if (q.suffix) return `${v} ${q.suffix}`;
  return String(v);
};

const ReviewScreen = ({ answers, onEditSection }) => {
  return (
    <div>
      <h2 className="font-serif text-3xl font-bold text-[#0B2343] mb-2">Review your answers</h2>
      <p className="text-sm text-slate-500 mb-8">
        Take a moment to review your consultation details. You can jump back to any section to
        edit an answer.
      </p>

      <div className="space-y-6">
        {SECTIONS.map((section) => {
          const visible = section.questions.filter((q) => !q.condition || q.condition(answers));
          if (visible.length === 0) return null;

          return (
            <div
              key={section.id}
              className="bg-white border border-slate-200 p-5"
              data-testid={`ic-review-${section.id}`}
            >
              <div className="flex justify-between items-start mb-3 pb-3 border-b border-slate-100">
                <h3 className="font-serif text-lg font-bold text-[#0B2343]">
                  {section.title}
                </h3>
                <button
                  onClick={() => onEditSection(section.id)}
                  data-testid={`ic-review-edit-${section.id}`}
                  className="text-xs text-[#C89B3C] hover:text-[#a8852f] inline-flex items-center gap-1"
                >
                  <Edit3 size={12} /> Edit
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
                {visible.map((q) => (
                  <div key={q.id} className="text-sm">
                    <div className="text-slate-500 text-xs uppercase tracking-wider mb-0.5">
                      {q.title.replace(/\?$/, "")}
                    </div>
                    <div className="text-[#0B2343] font-medium break-words">
                      {renderAnswer(q, answers)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewScreen;
